import React from "react";
import "./Contact.css";
import ig from "../assets/ig.svg";
import fb from "../assets/fb.svg";
import logo from "../assets/logo.svg";

export const Contact = () => {
  return (
    <div id="Contact">
      <div className="contact-container container">
        {<img alt="logo" className="logo" src={logo} />}
      </div>
      <footer>
        <div className="footer-container">
          <div className="contact-me">
            <h2>Contact me</h2>
            <p>polickovaya.n.gmail.com</p>
            <a href="12393788887">
              <p>+1(239)378-8887</p>
            </a>
          </div>
          <div className="social">
            <h2>Social</h2>
            <div className="social-icons">
              <a
                href="https://www.instagram.com/nadzeyat/?igshid-MzRIODBiNWFIZA%3D%3d"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="instagram" src={ig} />
              </a>
              <a
                href="https://www.facebook.com/nadya.politscovaya"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="facebook" src={fb} />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
